import { createIncludedLookup } from '../../../schema/validation/createIncludedLookup'
import { type CacheUpdateFn } from '../../../util/buildQueryHelpers'
import { type MomentWorkflowsDocument } from '../readMomentWorkflows'

/**
 * Replaces the workflows of the given moments with the incoming ones. A moment
 * that has no incoming workflow loses its cached one. The contexts of removed
 * workflows stay in `included`.
 */
export const replaceMomentWorkflows =
  (
    legacyMomentIds: number[],
    incoming: MomentWorkflowsDocument
  ): CacheUpdateFn<MomentWorkflowsDocument> =>
  (draft) => {
    const replacedMomentIds = new Set(legacyMomentIds.map(String))
    const findIncluded = createIncludedLookup(draft.included, 'V2')

    draft.data = draft.data.filter((workflow) => {
      const momentId = findIncluded(
        'context',
        workflow.relationships.context?.data.id
      )?.relationships.moment?.data.id
      return momentId === undefined || !replacedMomentIds.has(momentId)
    })
    draft.data.push(...incoming.data)

    const includedByKey = new Map(
      (draft.included ?? []).map((resource) => [
        `${resource.type}:${resource.id}`,
        resource,
      ])
    )
    incoming.included?.forEach((resource) =>
      includedByKey.set(`${resource.type}:${resource.id}`, resource)
    )
    draft.included = [...includedByKey.values()]

    return draft
  }
